import Card from '../Card';

function ProductList({items, title, path}){
    return <section className="list-card-container">          
        <div className="list-card-header">  
            <h2>{title}</h2>
        </div>    
        <div className="list-card">
            {items.map(i => <Card item={i} title={i.title} path={path}/>)}            
        </div>
    </section>
}

export default ProductList;